import { Injectable } from '@angular/core';
import { CoresService } from './cores.service';
import * as Cesium from 'cesium';
import { HeadingPitchRange, Viewer } from 'cesium';
import { catchError, forkJoin, MonoTypeOperatorFunction, Observable, Subject ,of} from 'rxjs';
import { ConfigurationManagerService } from './configuration-manager.service';
import { ApiService } from './api.service';
import { BuildingUsersResponse } from '../models/building-user-data.model';
import { DataContextService } from './data-context.service';
import { DetailsWindowComponent } from '../../components/shared/details-window/details-window.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from './alert.service';
import { MonitorCardComponent } from '../../components/shared/monitor-card/monitor-card.component';
import { OrganizationService } from './organization.service';
import { VehicleAlertFocusService } from './vehicle-alert-focus.service';
import { Injector } from '@angular/core';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  pipe(arg0: MonoTypeOperatorFunction<unknown>) {
    throw new Error('Method not implemented.');
  }
  ellipsoid: any;
  cartographic = new Cesium.Cartographic();
  cameraChangeListeners: any = {};
  private entityCameraSubject = new Subject<any>();
  entityCamera$ = this.entityCameraSubject.asObservable();
  appState: { defaultCameraState: boolean } = { defaultCameraState: true };
  private _currentIncidentId: any;
  private _hideEventDetailsForLiveNotification: boolean = false;
  private _isBuildingCameraOpen: boolean = false;
  private _alertService: AlertService | null = null;
  constructor(
    private cores: CoresService,
    private api: ApiService,
    private dataContext: DataContextService,
    private modalService: NgbModal,
    private injector: Injector,
    private organizationService:OrganizationService,
    public windowService: WindowService
  ) {}
resetCurrentIncidentId(): void {
    this._currentIncidentId = undefined;
  }

  setCurrentIncidentId(incidentId: any): void {
    this._currentIncidentId = incidentId;
  }
  getCurrentIncidentId() {
    return this._currentIncidentId;
  }
  setHideEventDetailsForLiveNotification(value: boolean): void {
    this._hideEventDetailsForLiveNotification = value;
  }
  getHideEventDetailsForLiveNotification(): boolean {
    return this._hideEventDetailsForLiveNotification;
  }
  setIsBuildingCameraOpen(value: boolean): void {
    this._isBuildingCameraOpen = value;
  }
  isBuildingCameraOpen(): boolean {
    return this._isBuildingCameraOpen;
  }
  useEntityCamera(entity: any): void {
    this.entityCameraSubject.next(entity);
  }
  
  flyHome(duration: any){
		this.cores.getViewer().camera.flyHome(duration);
	};

 getUserStatusInBuilding(buildingPerimeterId: number): Observable<BuildingUsersResponse> {
  const url = ConfigurationManagerService.settings.TezAddPapiBaseUrl + `building/${buildingPerimeterId}/users/`;
    return this.api.get(url);
  }
  getCampusUserStatusInBuilding(buildingPerimeterId: number): Observable<BuildingUsersResponse> {
    const url = ConfigurationManagerService.settings.TezAddPapiBaseUrl + `campus/${buildingPerimeterId}/campusUsers/`;
    return this.api.get(url);
  }

  _MAX_ZOOM: any = 26194.6; // KM
  _MIN_ZOOM: any = 0.1; // KM

  start() {
    this.ellipsoid = this.cores.getViewer().scene.mapProjection.ellipsoid;

    this.cores.getViewer().camera.moveStart.addEventListener(() => {
      this.ellipsoid.cartesianToCartographic(this.cores.getViewer().camera.positionWC, this.cartographic);

      this.fireEventHandlers((this.cartographic.height * 0.001).toFixed(1), this.cores.getViewer().camera.pitch, this.cores.getViewer().camera.roll, this.cores.getViewer().camera.frustum);
    });

    this.cores.getViewer().camera.moveEnd.addEventListener(() => {
      this.ellipsoid.cartesianToCartographic(this.cores.getViewer().camera.positionWC, this.cartographic);

      this.fireEventHandlers((this.cartographic.height * 0.001).toFixed(1), this.cores.getViewer().camera.pitch, this.cores.getViewer().camera.roll, this.cores.getViewer().camera.frustum);
    });

    this.cores.getViewer().scene.screenSpaceCameraController.maximumZoomDistance = this._MAX_ZOOM * 1000;
  }

  fireEventHandlers(height: any, pitch: any, roll: any, frustum: any) {
    for (const key in this.cameraChangeListeners) {
      this.cameraChangeListeners[key](height, pitch, roll, frustum);
    }
  }

addCameraChangeListener(key: string, listener: (height: number, pitch: number, roll: number, frustum: any) => void): void {
  this.cameraChangeListeners[key] = listener;
}

  removeCameraChangeListener(key: string): void {
    delete this.cameraChangeListeners[key];
  }

  // flyToEntity(
  //   entity: any,
  //   offset?: HeadingPitchRange
  // ): Promise<boolean> | undefined {
  //   const viewer: Viewer = this.cores.getViewer();

  //   if (!offset) {
  //     offset = new HeadingPitchRange(0.0, -Math.PI / 2.0, 0.0);
  //   }

  //   if (this.appState.defaultCameraState) {
  //     return viewer.flyTo(entity, { offset });
  //   }

  //   return;
  // }
  flyToEntity(entity: any, offset?: HeadingPitchRange): Promise<boolean> | undefined {
    const viewer = this.cores.getViewer();
    if (!viewer || !entity) {
      return Promise.resolve(false);
    }
    if (!offset) {
      offset = new Cesium.HeadingPitchRange(0.0, -Math.PI / 2.0, 0.0);
    }

    if (this.appState.defaultCameraState) {
      return viewer.flyTo(entity, { offset: offset });
    }
    return Promise.resolve(false);
  }


  flyToEntityWithSideView(
    entity: any,
    headingAngle: number = Math.PI / 2,
    pitchAngle: number = -Math.PI / 6,
    range?: number
  ): Promise<boolean> | undefined {
    const viewer: Viewer = this.cores.getViewer();
    if (!viewer || !entity) {
      return Promise.resolve(false);
    }

    const offset = new HeadingPitchRange(
      headingAngle, 
      pitchAngle, 
      range || 0.0
    );

    if (this.appState.defaultCameraState) {
      return viewer.flyTo(entity, { offset });
    }

    return Promise.resolve(false);
  }
  flyTo(options: any): void {
    const viewer = this.cores.getViewer();
    if (viewer?.camera) {
      viewer.camera.flyTo(options);
    }
  }
clearLookAt(): void {
  const viewer = this.cores.getViewer();
  viewer?.camera?.lookAtTransform(Cesium.Matrix4.IDENTITY);
}

flyToLocation(
  latitude: number,
  longitude: number,
  entity?: any
): void {
  const viewer = this.cores.getViewer();
  if (!viewer?.camera || typeof latitude !== 'number' || typeof longitude !== 'number') {
    return;
  }
  this.clearLookAt();
  const earthRadius = 6371000;
  const mapEntity = entity && typeof entity === 'object' ? entity : undefined;

  // 🏢 Get building height from entity or fallback to 100m
  const buildingHeight = mapEntity?.building?.height ?? 100;

  // 🔸 Dynamic distance & camera height
  const distance: number = buildingHeight * 5 + 500;
  const height: number = buildingHeight * 1.5 + 200;
  const headingDeg = 220;
  const radHeading = Cesium.Math.toRadians(headingDeg);

  // Offset camera behind the target
  const offsetLat = latitude + (distance / earthRadius) * (180 / Math.PI) * Math.cos(radHeading);
  const offsetLon = longitude + (distance / earthRadius) * (180 / Math.PI) * Math.sin(radHeading) / Math.cos(Cesium.Math.toRadians(latitude));

  const cameraPosition = Cesium.Cartesian3.fromDegrees(offsetLon, offsetLat, height);
  const targetPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude, 0);
  const transform = Cesium.Transforms.eastNorthUpToFixedFrame(targetPosition);

  viewer.camera.lookAtTransform(transform);

  viewer.camera.setView({
    destination: cameraPosition,
    orientation: {
      heading: Cesium.Math.toRadians(headingDeg + 180), // face toward building
      pitch: Cesium.Math.toRadians(-10),                // look slightly downward
      roll: 0.0,
    },
  });

  if (mapEntity) {
    const resolved = this.dataContext.getMapEntity(mapEntity);
    this.useEntityCamera(resolved?.arcLiveMapEntity);

    if (!mapEntity.isBuildingIncident?.()) {
      mapEntity.goToEntity?.(() => {});
    } else {
      mapEntity.viewDetailsWindow?.(this);
    }
  }
}

flyToVehicleFocus(latitude: number, longitude: number): void {
  const viewer = this.cores.getViewer();
  if (!viewer?.camera) {
    return;
  }
  viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
  viewer.camera.flyTo({
    destination: Cesium.Cartesian3.fromDegrees(longitude, latitude, 1800),
    orientation: {
      heading: viewer.camera.heading,
      pitch: Cesium.Math.toRadians(-89),
      roll: 0
    },
    duration: 1.2
  });
}

// flyToLocation(
//   latitude: number,
//   longitude: number,
 
//   entity?: any
// ): void {
//   const viewer = this.cores.getViewer();
//   const earthRadius = 6371000;
//    const distance: number = 2000;  // Distance from target
//   const headingDeg: number = 220; // Direction toward building
//  const height: number = 500; 
//   const radHeading = Cesium.Math.toRadians(headingDeg);

//   // Offset camera behind the target
//   const offsetLat = latitude + (distance / earthRadius) * (180 / Math.PI) * Math.cos(radHeading);
//   const offsetLon = longitude + (distance / earthRadius) * (180 / Math.PI) * Math.sin(radHeading) / Math.cos(Cesium.Math.toRadians(latitude));

//   const cameraPosition = Cesium.Cartesian3.fromDegrees(offsetLon, offsetLat, height);
//   const targetPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude, 0);
//   const transform = Cesium.Transforms.eastNorthUpToFixedFrame(targetPosition);

//   viewer.camera.lookAtTransform(transform);

//   viewer.camera.setView({
//     destination: cameraPosition,
//     orientation: {
//       heading: Cesium.Math.toRadians(headingDeg + 180), // face toward building
//       pitch: Cesium.Math.toRadians(-10),                // look slightly downward
//       roll: 0.0,
//     },
//   });

//   if (entity) {
//     const mapEntity = this.dataContext.getMapEntity(entity.id);
//     this.useEntityCamera(mapEntity?.arcLiveMapEntity);

//     if (!entity.isBuildingIncident?.()) {
//       entity.goToEntity?.(() => {});
//     } else {
//       entity.viewDetailsWindow?.(this);
//     }
//   }
// }

openDetailsWindow(mapEntity: any, windowId: any) {
  const modalRef = this.modalService.open(DetailsWindowComponent, {
    backdrop: false,
    keyboard: false,
    windowClass: 'modal-class'
  });
  modalRef.componentInstance.mapEntity = mapEntity;

  setTimeout(() => this.makeModalDraggable(), 0);

  this.windowService.openModalRefs[windowId] = modalRef;

  if (windowId) {
    modalRef.closed.subscribe(() => {
      delete this.windowService.openWindows[windowId];
      delete this.windowService.openModalRefs[windowId];
    });
    modalRef.dismissed.subscribe(() => {
      delete this.windowService.openWindows[windowId];
      delete this.windowService.openModalRefs[windowId];
    });
  }
}

  makeModalDraggable() {
    const modals = document.querySelectorAll('.modal-class .modal-dialog') as NodeListOf<HTMLElement>;
    modals.forEach(modal => {
      const header = modal.querySelector('.modal-header') as HTMLElement;
      if (modal && header && !header.hasAttribute('data-draggable')) {
        let isDragging = false;
        let offsetX = 0;
        let offsetY = 0;

        header.style.cursor = 'move';
        header.setAttribute('data-draggable', 'true');

        header.addEventListener('mousedown', (event) => {
          isDragging = true;
          const rect = modal.getBoundingClientRect();
          offsetX = event.clientX - rect.left;
          offsetY = event.clientY - rect.top;

          const onDrag = (event: MouseEvent) => {
            if (!isDragging) return;
            modal.style.position = 'fixed';
            modal.style.margin = '0';
            modal.style.left = `${event.clientX - offsetX}px`;
            modal.style.top = `${event.clientY - offsetY}px`;
          };

          const stopDrag = () => {
            isDragging = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
          };

          document.addEventListener('mousemove', onDrag);
          document.addEventListener('mouseup', stopDrag);
        });
      }
    });
  }

  moveUp(amount: number): void {
    this.cores.getViewer().camera.moveUp(amount);
  }

  moveDown(amount: number): void {
    const viewer = this.cores.getViewer();
    if (viewer) {
      viewer.camera.moveDown(amount);
    }
  }

  getPitch(): number | undefined {
    const viewer = this.cores.getViewer();
    if (viewer) {
      return viewer.camera.pitch;
    }
    return undefined;
  }

  getMaxZoomInKM(): number {
    return this._MAX_ZOOM;
  }

  getMinZoomInKM(): number {
    return this._MIN_ZOOM;
  }
   runAlert(event: MouseEvent, item: any): void {
      const vehicleAlertFocus = this.injector.get(VehicleAlertFocusService);
      if (vehicleAlertFocus.focusFromAlert(item)) {
        return;
      }
      vehicleAlertFocus.leaveVehicleViewForStandardAlert();
      const newItem = { ...item };
      newItem.seeInfo = () => {
        if (typeof newItem.showInfo === 'function') {
          newItem.showInfo();
        }
      };
  
      const openModalWithData = (dataItem: any) => {
        const title = "Alert Details";
        this.handleFlyToUserLocation(dataItem);
        this.openDetailsModal(title, dataItem, true);
      };
  
      if (newItem.id) {
        forkJoin({
          userDetails: this.organizationService.getProfilesFromOrganization(newItem.userId).pipe(
            catchError(err => {
              console.error("Error fetching user details:", err);
              return of(null); // Provide fallback so forkJoin still completes
            })
          ),
          sopDetails: this.organizationService.getSOP(newItem.id).pipe(
            catchError(err => {
              console.error("Error fetching SOP details:", err);
              return of(null); // Provide fallback so forkJoin still completes
            })
          ),
         
          alertPayload: this.alertService.getAlertById(newItem.id).pipe(
            catchError(err => {
              console.error("Error fetching alert details:", err);
             return of(null);// Provide fallback so forkJoin still completes
            })
          )       
        }).subscribe(({ userDetails, alertPayload,sopDetails }) => {
          newItem.userDetails = userDetails;
          newItem.alertPayload = alertPayload;
          newItem.sopDetails=sopDetails;
          openModalWithData(newItem);
        });
      } else {
        openModalWithData(newItem);
      }
    }
    
      private openDetailsModal(
        title: string,
        data: any,
        shouldCallApi: boolean
      ) {
        const modalRef = this.modalService.open(MonitorCardComponent, {
          size: 'lg',
          centered: true,
          backdrop: 'static',
          windowClass: 'response-modal-top zindex',
          backdropClass: 'response-modal-backdrop-top',
          keyboard: false,
        });
    
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.alertInfo = data;
        modalRef.componentInstance.shouldCallApi = shouldCallApi;
    
        return modalRef.result;
      }
      //map fly-to logic
      private handleFlyToUserLocation(alertInfo: any): void {
        const coordinates = alertInfo?.buildingInfo?.[0]?.room?.geometry?.coordinates;
    
        if (!coordinates || !Array.isArray(coordinates[0])) {
          const featureCoords = alertInfo?.AlertFeatures?.[0]?.geometry?.coordinates;
          if (Array.isArray(featureCoords) && typeof featureCoords[0] === 'number' && typeof featureCoords[1] === 'number') {
            this.flyToLocation(featureCoords[1], featureCoords[0]);
          }
          return;
        }
    
        const coords = coordinates[0]; // first ring of polygon or coordinate array
    
        // If it's a single point (e.g. [lon, lat])
        if (Array.isArray(coords) && coords.length === 2 && typeof coords[0] === 'number') {
          const [longitude, latitude] = coords;
          this.flyToLocation(latitude, longitude);
          return;
        }
    
        // If it's a polygon (array of [lon, lat] pairs)
        if (Array.isArray(coords) && Array.isArray(coords[0])) {
          const latitudes = coords.map(coord => coord[1]);
          const longitudes = coords.map(coord => coord[0]);
    
          const avgLat = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
          const avgLng = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;
    
          this.flyToLocation(avgLat, avgLng);
          return;
        }
    
      }

  get alertService(): AlertService {
    if (!this._alertService) {
      this._alertService = this.injector.get(AlertService);
    }
    return this._alertService;
  }

  goToDestination(destination: Cesium.Cartesian3, orientation: { heading: number; pitch: number; roll: number }) {
    const viewer = this.cores.getViewer();
    if (viewer && destination) {
      viewer.camera.flyTo({
        destination,
        orientation
      });
    }
  }
}